/**
 * 消息相关接口
 */
const api = '/checkmall-message'
export default {
    // 所有消息
    getMsg: api + "/api/msg/getPage",
    // 消息详情
    selectMessageDetail: api + "/api/msg/readMsg",
    // 消息类型
    msgType:api + "/api/msg/getMessageType"
}